export default "__VITE_ASSET__28eb6eb8__"